// Quick shop: [data-quick-shop="<product url>"] buttons on product cards open the product in a
// popup. The popup's HTML is the quick-shop section, fetched with the Section Rendering API.
// Choosing a variant re-fetches it for that variant; Add to cart is handled by cart.js, which
// fires `cart:added`, and the popup closes so the cart drawer can open.
(() => {
  const dialog = document.getElementById('quick-shop');
  if (!dialog) return;
  const body = dialog.querySelector('[data-quick-shop-body]');
  let opener = null;

  async function load(url, variantId) {
    const u = new URL(url, window.location.origin);
    u.searchParams.set('section_id', 'quick-shop');
    if (variantId) u.searchParams.set('variant', variantId);
    dialog.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(u, { headers: { Accept: 'text/html' } });
      if (!res.ok) throw new Error(res.status);
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const content = doc.querySelector('[data-quick-shop-content]');
      if (!content) throw new Error('no content');
      body.replaceChildren(content);
    } catch {
      window.location.href = url; // fall back to the product page
    } finally {
      dialog.removeAttribute('aria-busy');
    }
  }

  function open(url, trigger) {
    opener = trigger;
    body.innerHTML = '<p class="p-10 text-center text-lg text-foreground/60">Loading…</p>';
    if (!dialog.open) dialog.showModal();
    requestAnimationFrame(() => dialog.classList.add('is-open'));
    load(url);
  }

  function close() {
    if (!dialog.open) return;
    dialog.classList.remove('is-open');
    dialog.close();
    opener?.focus();
  }

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-quick-shop]');
    if (trigger) { e.preventDefault(); open(trigger.dataset.quickShop, trigger); return; }
    if (e.target.closest('[data-quick-shop-close]')) { close(); return; }
    const thumb = e.target.closest('[data-quick-shop-thumb]');
    if (thumb && dialog.contains(thumb)) {
      const main = dialog.querySelector('[data-quick-shop-main]');
      if (main) { main.removeAttribute('srcset'); main.src = thumb.dataset.quickShopThumb; }
      dialog.querySelectorAll('[data-quick-shop-thumb]').forEach((b) => {
        b.classList.toggle('border-link', b === thumb);
        b.classList.toggle('border-border', b !== thumb);
      });
    }
  });

  dialog.addEventListener('change', (e) => {
    const select = e.target.closest('[data-quick-shop-variant]');
    if (!select) return;
    const content = dialog.querySelector('[data-quick-shop-content]');
    load(content.dataset.productUrl, select.value);
  });

  dialog.addEventListener('click', (e) => { if (e.target === dialog) close(); });
  dialog.addEventListener('cancel', (e) => { e.preventDefault(); close(); });
  document.addEventListener('cart:added', close);
})();
